import React from 'react'
import { connect } from 'react-redux'

import Tile from './tile'
import Figure from './figure'
import './mosaic.css'

/*const Mosaic = ( { tile, currentColors }) => {
	return (<div id="grid-container">
		{tile.rotations.map((r,i) => {
			return (<Tile width='100' height='100' onSelectTile={()=> {}}>
			{tile.paths.map(( path, pathIndex ) => {
				return (
					<Figure 
						id={pathIndex} 
						key={pathIndex} 
						transform={'rotate('+r+' '+'100 100)'} 
						d={path.d} 
						fill={currentColors[pathIndex]}
					/>
				)
			})}
			</Tile>)
		})}
	</div>)
}*/

const Mosaic = ({ tile, currentColors }) => {
	const styledTile = {
		border: '1px dotted #666666'
	};

	console.log(tile)

	return (<div id="grid-container">
		<svg width="400" height="400" viewBox="0 0 800 800">
			{tile.rotations.map((r, i) => {
				const type = tile.type;
				const transform = calcPosition(i, r, type);
				return (<g transform={transform}>
					{tile.paths.map((path, pathIndex) => {
						return (
							<path
								id={pathIndex}
								key={pathIndex}
								d={path.d}
								fill={currentColors[pathIndex]}
							/>
						)
					})}
				</g>)
			})}
		</svg>
	</div>)
}

const calcPosition = (i, r, type="normal") => {
	let transform='';
	if(type==="normal")
		transform='translate(' + ((i % 4) * 200 + 8) + ',' + (parseInt(i / 4) * 200 + 8) + ')';
	else{
		const xInicial = -50;
		const yInicial = -80;
		const numElementosFila = 6;
		const fila = parseInt(i/numElementosFila);
		const columna = i%numElementosFila;
		if( fila % 2 === 0){
			transform='translate(' + (xInicial+columna * 176 - 90 + 8) + ',' + (yInicial+fila * 150) + ')';
		}else{
			transform='translate(' + (xInicial+columna * 176 + 6) + ',' + (yInicial+fila * 150 ) + ')';
		}
		
	}
	transform+=' rotate(' + r + ' 100 100)';
	return transform;
}

/*const drawTile(tile, r, i) => {
	const t = tile.rotations.map((r,i) => {
		return ({tile.paths.map(( path, pathIndex ) => <path 
				id={pathIndex} 
				key={pathIndex} 
				transform={'translate('+(i%4)*50+'0 0) rotate('+r+'0 100 100)'} 
				d={path.d} 
				fill={currentColors[pathIndex]}
				/>
			)
		)
	})
}*/

const mapStateToProps = (state, props) => ({
	tile: state.tiles[state.selectedTile],
	currentColors: state.currentColors
});

const VisibleMosaic = connect(mapStateToProps, null)(Mosaic);

export default VisibleMosaic;



// WEBPACK FOOTER //
// ./src/components/mosaic/mosaic.jsx